import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, Container } from 'react-bootstrap';
import './TgPosts.css'
import Post from './Post';

function TgPosts() {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                const response = await axios.get('https://api.familybook.uz/api/tgposts');
                setPosts(response.data);
                setLoading(false);
            } catch (err) {
                setError('Ma\'lumotlarni yuklashda xatolik yuz berdi');
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);





    const parsePostData = (dataString) => {
        try {
            const data = JSON.parse(dataString);
            return {
                messageId: data.channel_post?.message_id,
                date: new Date(data.channel_post?.date * 1000).toLocaleDateString('uz-UZ'),
                caption: data.channel_post?.caption,
                video: data.channel_post?.video,
                photo: data.channel_post?.photo?.[0],
                author: data.channel_post?.author_signature,
                channelName: data.channel_post?.sender_chat?.title,
                quiz: data.channel_post?.poll,
                mediaType: data.channel_post?.video ? 'video' :
                    data.channel_post?.photo ? 'photo' :
                        data.channel_post?.poll ? 'quiz' : 'text'
            };
        } catch (err) {
            console.error('JSON parse error:', err);
            return null;
        }
    };

    if (loading) return <div className="text-center p-5">Yuklanmoqda...</div>;
    if (error) return <div className="text-center p-5 text-danger">{error}</div>;
    return (
        <Container className="tg-posts-container py-0">
            <h2 className="text-center mb-4">Qiziqarli testlar va Faktlar</h2>
            <div className="posts-feed">
                {posts.map((post) => {
                    const parsedData = parsePostData(post.data);
                    if (!parsedData) return null;

                    return (
                        <Post key={post.id} parsedData={parsedData} />
                    );
                })}
            </div>
        </Container>
    );
}

export default TgPosts;